import React from "react";
import ReactDOM from "react-dom/client";
import "./styles/index.css";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import { getBrand, applyBrandTheme } from "./brandResolver";

const root = ReactDOM.createRoot(document.getElementById("root"));

const brand = getBrand();
applyBrandTheme(brand);

root.render(
  <BrowserRouter>
    <App brand={brand} />
  </BrowserRouter>
);
